import { BidButton } from '../components/button/bid-button';
import { Image } from '../components/image/image';
import { Label, LabelVariant } from '../components/label/label';
import { LotDetails } from '../components/lot/lot-details';
import { Lot } from '../graphql/types';

// [number]. [vintner]
// [vintage] [title]
export function LotDetailsContainer({
  lot,
  actions,
  cardOnly,
  isLotClosed = false,
  buyersPremiumPercentage,
  overheadPremiumPercentage,
}: {
  lot: Pick<
    Lot,
    | 'title'
    | 'summary'
    | 'images'
    | 'number'
    | 'vintner'
    | 'vintage'
    | 'startsAt'
    | 'endsAt'
  > & {
    yourBid?: Partial<Lot['yourBid']>;
    highestBids: Lot['highestBids'];
  };
  actions?: React.ReactNode;
  cardOnly?: boolean;
  buyersPremiumPercentage?: number;
  overheadPremiumPercentage?: number;
  isLotClosed?: boolean;
}) {
  const yourBidIndex = lot.highestBids.findIndex(
    (bid) => bid.id === lot.yourBid?.id
  );
  const [highestBid] = lot.highestBids;

  return (
    <LotDetails
      image={
        <Image
          src={
            lot.images?.find((i: any) => i.size === 'original')?.url ??
            '/temp/wine_temp.png'
          }
          loading="eager"
          fit="contain"
          alt={lot.title}
        />
      }
      brandName={`${lot.number}. ${lot.vintner}`}
      status={
        lot.yourBid ? (
          yourBidIndex >= 0 ? (
            <Label variant={LabelVariant.Success}>
              You’re {yourBidIndex === 0 ? `a Leader` : 'on the Leaderboard'}
            </Label>
          ) : (
            <Label variant={LabelVariant.Warning}>Outbid</Label>
          )
        ) : undefined
      }
      title={lot.summary}
      summary=""
      highestBid={highestBid?.amount}
      startsAt={lot.startsAt}
      endsAt={lot.endsAt}
      actions={
        <>
          {actions}
          <BidButton startsAt={lot.startsAt} endsAt={lot.endsAt} />
        </>
      }
      cardOnly={cardOnly}
      isLotClosed={isLotClosed}
      buyersPremiumPercentage={buyersPremiumPercentage}
      overheadPremiumPercentage={overheadPremiumPercentage}
    />
  );
}
